import { isBrowser } from "@montana/helpers/browser.helper";

const localStorageAvailable = isBrowser && window.localStorage !== undefined;

export const setLocalStorageItem = (key: string, value: string): void => {
    if (localStorageAvailable) {
        window.localStorage.setItem(key, value);
    }
};

export const getLocalStorageItem = (key: string): string | null => {
    if (localStorageAvailable) {
        return window.localStorage.getItem(key);
    }

    return null;
};

export const removeLocalStorageItem = (key: string): void => {
    if (localStorageAvailable) {
        window.localStorage.removeItem(key);
    }
};
